import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import {
  BuildingGroupMultiSelect,
  BuildingGroupSelectFormikField,
} from '../../../../BuildingGroup'
import { BUILDING_FORM_FIELD_NAME_BUILDING_GROUP } from '../../BuildingForm.constants'

import * as styles from './BuildingGroupField.module.css'

function BuildingGroupField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingGroupSelectFormikField
      multi
      Select={BuildingGroupMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Building.GroupsPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Building.GroupLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={BUILDING_FORM_FIELD_NAME_BUILDING_GROUP}
      tagsProps={{
        className: styles.buildingGroupFieldTags,
      }}
    />
  )
}

export default BuildingGroupField
